<template>
  <div class="component-archives-card">
    <div class="archives-card">
      <div class="archives-card-content">
        <div class="top-header">
          <!-- <div class="right-btn font-bold" @click="handleDetail">详情</div> -->
          <el-button
            type="primary"
            class="right-btn"
            plain
            @click="handleDetail"
          >
            详情
          </el-button>
          <img style="border-radius: 50%" src="./img/head.png" alt="" />
          <div>
            <div class="name">
              {{ archivesDetail.archive.name }}
            </div>
            <div class="flex text-sm">
              <div class="mr-5">{{ archivesDetail.archive.age }}岁</div>
              <div class="flex items-center">
                <template v-if="archivesDetail.archive.gender == 1">
                  <img
                    class="gender-img"
                    src="./img/icon-gender-1.png"
                    alt=""
                  />
                  <div>男性</div>
                </template>
                <template v-else>
                  <img
                    class="gender-img"
                    src="./img/icon-gender-2.png"
                    alt=""
                  />
                  <div>女性</div>
                </template>
              </div>
            </div>
            <div class="mt-1">
              <!-- <el-button
                type="danger"
                style="font-size: 12px; padding: 6px 14px"
                >重点关爱人群</el-button
              > -->
              <el-button
                :type="getLevelBtn(archivesDetail.archive.riskLevel).type"
                class="plain"
                style="font-size: 10px; padding: 6px 14px"
                >{{
                  getLevelBtn(archivesDetail.archive.riskLevel).name
                }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="mt-2" style="height: 100%">
          <div
            class="flex"
            style="height: 100%; border: 1px solid #dcdfe6; border-radius: 10px"
          >
            <div class="theme-padding">
              <div style="width: 550px">
                <el-descriptions class="pl-3 pr-3">
                  <div slot="title">
                    <div style="color: #333">基本信息</div>
                  </div>

                  <el-descriptions-item
                    v-for="(item, index) in archivesDetail.base"
                    :key="index"
                    :label="item.key"
                  >
                    {{ item.value }}
                  </el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
                <el-descriptions :column="1" class="pl-3 pr-3">
                  <div slot="title">
                    <div style="color: #333">居住信息</div>
                  </div>
                  <el-descriptions-item
                    v-for="(item, index) in archivesDetail.address"
                    :key="index"
                    :label="item.key"
                  >
                    {{ item.value }}
                  </el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
                <div class="pl-3 pr-3">
                  <el-descriptions :column="1">
                    <div slot="title">
                      <div style="color: #333">疾病情况</div>
                    </div>
                  </el-descriptions>
                  <div
                    class="flex ill-box"
                    v-if="
                      archivesDetail.diseases && archivesDetail.diseases.length
                    "
                  >
                    <el-button
                      class="mr-4 ill-btn mb-2"
                      type="danger"
                      style="padding: 10px 10px"
                      v-for="(ill, index) in archivesDetail.diseases"
                      :key="index"
                      >{{ ill }}</el-button
                    >
                  </div>

                  <div v-else>
                    <el-button type="success" style="padding: 10px 10px"
                      >暂无数据</el-button
                    >
                  </div>

                  <!-- <div class="flex ill-box">
                    <el-button
                      class="mr-4 mb-2 ill-btn"
                      type="danger"
                      style="padding: 10px 10px"
                      v-for="(ill, index) in testList"
                      :key="index"
                      >{{ ill.name }}</el-button
                    >
                  </div> -->
                </div>
              </div>
            </div>
            <dv-border-box-12
              :color="[$color.borderColor, $color.borderColor]"
              style="min-height: 420px"
            >
            </dv-border-box-12>
            <div class="theme-padding" style="border-left: 1px solid #dcdfe6">
              <div style="height: 100%">
                <div class="pl-3 pr-3">
                  <el-descriptions :column="1">
                    <div slot="title">
                      <div style="color: #333">上门服务记录</div>
                    </div>
                  </el-descriptions>
                  <div>
                    <div
                      :id="`patrol-chart${chartId}`"
                      style="height: 340px; width: 510px"
                    ></div>
                  </div>
                  <!-- <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    height="300"
                    text
                  >
                    <el-table-column
                      prop="date"
                      label="巡访月份"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="value"
                      label="巡访次数"
                      align="center"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.value }}次</span>
                      </template>
                    </el-table-column>
                  </el-table> -->
                </div>
              </div>
            </div>
            <!-- <dv-border-box-12
              class="theme-padding"
              :color="[$color.borderColor, $color.borderColor]"
              style="height: 100%; display: inline-block; border: 1px solid red"
            >
            </dv-border-box-12> -->
          </div>
        </div>
      </div>
    </div>
    <ComponentDialogPatrolTime
      :show.sync="visible"
      :list="patrolList"
      :archivesDetail="archivesDetail"
      :sn="sn"
    ></ComponentDialogPatrolTime>
  </div>
</template>
<script>
import { formatRiskLevel } from "../../utils/index";
import { mapGetters } from "vuex";
import * as echarts from "echarts";
import ComponentDialogPatrolTime from "./PatrolTime.vue";
let myChart = null;
export default {
  components: {
    ComponentDialogPatrolTime,
  },
  data() {
    return {
      testList: [
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },

        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
        {
          name: "哮喘、焦虑症、静脉曲张",
        },
      ],
      tableData: [
        {
          date: "一月",
          value: 2,
        },
        {
          date: "二月",
          value: 2,
        },
        {
          date: "三月",
          value: 2,
        },
        {
          date: "四月",
          value: 2,
        },
        {
          date: "五月",
          value: 2,
        },
        {
          date: "六月",
          value: 2,
        },

        {
          date: "七月",
          value: 2,
        },
        {
          date: "八月",
          value: 2,
        },
        {
          date: "九月",
          value: 2,
        },
        {
          date: "十月",
          value: 2,
        },
        {
          date: "十一月",
          value: 2,
        },
        {
          date: "十二月",
          value: 2,
        },
      ],
      archivesDetail: {
        archive: {},
        base: [],
        address: [],
        diseases: [],
      },
      visible: false,
      patrolList: [],
      myChart,
      chartId: new Date().getTime(),
    };
  },
  props: {
    sn: {
      type: String,
      default: "",
    },

    link: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    sn: {
      handler(n) {
        if (!n) {
          return;
        } else {
        }
        // this.getArchivesDetail();
      },
      deep: true,
    },
    detail: {
      handler(n) {
        this.archivesDetail = n;
        setTimeout(() => {
          // console.log("监听成功", n);
          // this.$nextTick(() => {
          //   // this.initReduceChart();
          // });
        }, 2000);
      },
      deep: false,
    },
  },
  computed: {},
  ...mapGetters(["globalData", "key", "token", "plotKey"]),
  methods: {
    echartDispose() {
      console.log(myChart);
      if (myChart) {
        echarts.dispose(myChart);
        myChart = null;
      }
      console.log("myChart====>dispose", myChart);
    },
    getLevelBtn(level = 0) {
      let list = [
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "success",
          name: formatRiskLevel(level),
        },
        {
          type: "warning",
          name: formatRiskLevel(level),
        },
        {
          type: "danger",
          name: formatRiskLevel(level),
        },
      ];
      return list[level];
    },
    async handleDetail() {
      if (!this.sn) return;
      let token = await this.$store.dispatch("app/getToken");
      let link = `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${token}&&key=${this.sn}`;
      window.open(link);
    },

    initReduceChart() {
      this.echartDispose();
      this.$nextTick(() => {
        const backgroundColor = "";
        const color = ["#34C724", "#FF8800", "#F54A45"]; //2个以上的series就需要用到color数组
        const title = {
          text: "",
          textStyle: {
            color: "#333",
            fontSize: 16,
          },
          padding: 0,
          top: 35,
          left: 25,
        };
        const legend = {
          //data，就是取得每个series里面的name属性。
          // orient: "horizontal",
          // icon: "circle", //图例形状
          // padding: 0,
          top: 18,
          right: 40,
          // itemWidth: 11, //小圆点宽度
          // itemHeight: 11, // 小圆点高度
          // itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 10,
            color: "#333",
          },
        };
        const tooltip = {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          // formatter: function (val) {
          //   var tipText = "";
          //   tipText +=
          //     val[0].name +
          //     " : " +
          //     "<br/>" +
          //     val[0].marker +
          //     val[0].seriesName +
          //     " : " +
          //     val[0].value +
          //     "%<br/>" +
          //     val[1].marker +
          //     val[1].seriesName +
          //     " : " +
          //     val[1].value +
          //     "%<br/>" +
          //     val[2].marker +
          //     val[2].seriesName +
          //     " : " +
          //     val[2].value +
          //     "%<br/>";
          //   return tipText;
          // },
        };
        // let seriesData = [
        //   {
        //     name: "巡访次数",
        //     data: this.detail.visitLogsDetail.map((v) => v.length),
        //     data: this.detail.visitLogs.seriesData
        //     // data: this.tableData.map((v) => v.value),
        //   },
        // ];
        let seriesData = this.detail.visitLogs.seriesData;
        seriesData.forEach((v) => (v.name = "服务记录"));
        console.log(this.detail.visitLogsDetail.map((v) => v.length));
        const commonConfigFn = (index) => {
          return {
            type: "line",
            smooth: false,
            symbol: "emptyCircle", //空心小圆点。线条小圆点形状
            symbolSize: 6, //小圆点大小
            itemStyle: {
              //还是小圆点设置
            },

            label: {
              show: false, //不显示小圆点上的label文字
            },
            lineStyle: {
              width: 1, //线条设置
            },

            areaStyle: {
              //填充线条下面的面积区域颜色。（areaStyle只是锦上添花）
              opacity: 0.2,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: color[index], // 上处的颜色
                  },
                  {
                    offset: 1,
                    color: "transparent", // 下处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          };
        };

        seriesData = seriesData.map((item, index) => ({
          ...item,
          ...commonConfigFn(index),
        }));
        let option = {
          backgroundColor,
          color,
          title,
          tooltip,
          // legend,
          grid: {
            top: "20%",
            left: "3%",
            right: "4%",
            bottom: "5%",
            containLabel: true,
          },

          xAxis: {
            show: true, //显示x轴+x轴label文字
            type: "category",
            boundaryGap: false, //从Y轴出发，这个false很好的
            axisLine: {
              show: true, //显示x坐标轴轴线
              lineStyle: {
                color: "rgba(255,255,255,.4)",
              },
            },
            axisTick: {
              show: false, //不显示x坐标1cm刻度
            },
            axisLabel: {
              color: "#333",
              textStyle: {
                fontSize: 13,
              },
            },
            splitLine: {
              show: false, //不显示grid竖向分割线
            },

            data: this.detail.visitLogs.data,
          },
          yAxis: {
            type: "value",
            interval: 20, //间隔
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e2e9ff",
              },
            },
            axisLabel: {
              color: "#e2e9ff",
              textStyle: {
                fontSize: 13,
              },
              formatter: function (val) {
                //百分比显示
                return val + "";
              },
            },
            splitLine: {
              show: true, //不显示grid水平分割线
              type: "dashed",
              lineStyle: {
                // color: "#e2e9ff",
                color: "rgba(255,255,255,0.15)",
              },
            },
          },
          series: seriesData,
        };
        myChart = echarts.init(
          document.getElementById(`patrol-chart${this.chartId}`)
        );
        myChart.setOption(option);

        myChart.off("click");
        myChart.on("click", (params) => {
          console.log(params);
          let index = params.dataIndex;
          console.log(this.archivesDetail.visitLogsDetail);
          if (!this.archivesDetail.visitLogsDetail[index].length) {
            return this.$EditionEmptyDialog({
              show: true,
            });
          }
          this.patrolList = this.archivesDetail.visitLogsDetail[index];
          this.visible = true;
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.component-archives-card {
  backdrop-filter: blur(10px);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  .archives-card {
    height: 100%;
    // width: 520px;
    width: 100%;
    // border: 1px solid #ddd;
    // background: #333;
    border: 1px solid #dcdfe6;
    .theme-padding {
      //   padding: 20px 0;
      padding: 20px 0px;
    }
    .archives-card-content {
      padding: 20px;
      .top-header {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 80px;
        color: #333;
        position: relative;
        border-radius: 10px;
        .right-btn {
          position: absolute;
          right: 50px;
          top: 10px;
        }
        img {
          width: 74px;
          height: 74px;
          margin-right: 10px;
        }
        .name {
          font-size: 20px;
          font-weight: bold;
        }
        // background: linear-gradient(-90deg, #0e2f4e 0%, #0a1828 100%);
        // background: linear-gradient(
        //   to left,
        //   #0d0c2f 0%,
        //   #103253 50%,
        //   #0d0c2f 100%
        // );
        background: @background-color;
      }
      .gender-img {
        width: 16px !important;
        height: 16px !important;
      }
    }
    .ill-box {
      display: inline-block;
    }
    .ill-btn {
      color: #f56c6c !important;
      /* background-color: #F56C6C; */
      border-color: #f56c6c !important;
      background: transparent;
    }
    .exporttable {
    }

    ::v-deep {
      .el-table::before {
        height: 0;
      }
      .el-table--border::after,
      .el-table--group::after {
        width: 0;
      }
      /**
改变边框颜色
 */
      .el-table--border,
      .el-table--group {
        border: 1px solid #dcdfe6 !important;
      }
      /**
改变表格内竖线颜色
 */
      .el-table--border td,
      .el-table--border th,
      .el-table__body-wrapper
        .el-table--border.is-scrolling-left
        ~ .el-table__fixed {
        border-right: 1px solid #dcdfe6 !important;
      }
      /**
改变表格内行线颜色
 */
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #dcdfe6 !important;
      }

      .el-table thead tr th {
        border-color: #4bace0;
      }
      .el-table,
      .el-table__body {
        background: transparent !important;
        color: #abd1e7;
      }
      .el-table th {
        color: #abd1e7;
        background-color: transparent !important;
      }
      .el-table tr {
        background-color: transparent !important;
      }
      .el-table__body tr.hover-row > td {
        background-color: #a5ccf2 !important;
      }
      .el-table tbody tr:hover > td {
        background-color: #17468d !important; //修改成自己想要的颜色即可
      }
      .el-descriptions__body {
        // color: #abd1e7;

        background: transparent !important;
      }
      .el-divider {
        // background: #abd1e7;
      }
      .el-divider--horizontal {
        margin: 10px 0;
      }
      // .el-button {
      //   color: #f56c6c;
      //   /* background-color: #F56C6C; */
      //   border-color: #f56c6c;
      //   background: transparent;
      // }
    }
  }
}
</style>
